import type { ConfigDTO } from '../types'

export function encodeConfigId(config: ConfigDTO): string {
  const obj = {
    configKey: config.configKey,
    ...(config.tenantCode ? { tenantCode: config.tenantCode } : {}),
    ...(config.inventorySystemProfileCode
      ? { inventorySystemProfileCode: config.inventorySystemProfileCode }
      : {}),
    ...(config.venueId ? { venueId: config.venueId } : {}),
  }
  return btoa(JSON.stringify(obj))
}
